'use strict';

angular.module('searchModule')

.controller('RefineFacetGroupPublishedDateController', ['$scope',function ($scope) {

    $scope.refineFacetsById.DisplayedRefineFacetsByColumnValue =
        _.orderBy($scope.refineFacetsById.RefineFacetsByColumnValue, ['ColumnValue'], ['desc']);

}]);